import { ChatHistory } from "@/components/ChatBox";
import { AffordabilityRequestPayload } from "@/interfaces/propertyinterface";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";

const API_URL = process.env.NEXT_PUBLIC_CHAT_BOT_API_URL;

interface ChatBotState {
  chat: string[];
  loading: boolean;
  chatHistoryLoader: boolean;
  affordabilityData: null;
  error: string | null;
}

const initialState: ChatBotState = {
  chat: [],
  loading: false,
  affordabilityData: null,
  chatHistoryLoader: false,
  error: null,
};

interface ChatBot {
  auth: string | null;
  question: string;
  IP: string | null;
}

export interface GuestFormDataPayload {
  name: string,
  email: string,
  phone: string,
  IP: string
}


export const handleChatBot = createAsyncThunk(
  "chatbot/postChatBot",
  async (data: ChatBot, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/chat`, data);
      return response?.data;
    } catch (error) {
      console.log("error in chatbot", error);
    }
  }
);

export const getChatHistory = createAsyncThunk(
  "chat/getChatHistory",
  async (data: ChatHistory, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/chat_history`, data);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch Chat History"
        );
      } else {
        // Handle other types of errors, if necessary
        return rejectWithValue("An unknown error occurred");
      }
    }
  }
);

export const getUserByIp = createAsyncThunk('chat/getUserById', async(credentials : {ip: string}, {rejectWithValue}) => {
  try {
    const response = await axios.get(`${API_URL}/guest_details?IP=${credentials.ip}`)
    return response.data
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to fetch user"
        );
      } else {
        // Handle other types of errors, if necessary
        return rejectWithValue("An unknown error occurred");
      }
  }
})


export const deleteChatHistory = createAsyncThunk('chat/deleteChatHistory', async(credentials: {ip: string}, {rejectWithValue}) => {
  try {
    const response = await axios.delete(`${API_URL}/delete_chat/${credentials.ip}`)
    return response.data
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to delete Chat History"
        );
      } else {
        // Handle other types of errors, if necessary
        return rejectWithValue("An unknown error occurred");
      }
  }
})


export const sendChatBotFormData = createAsyncThunk('chat/sendFormData', async(credentials :GuestFormDataPayload, {rejectWithValue}) => {
  try {
    const response = await axios.post(`${API_URL}/submit_form`,credentials)
    return response.data
  } catch (error) {
    if (error instanceof AxiosError) {
        return rejectWithValue(
          error.response?.data?.message || "Failed to post chatbot form data"
        );
      } else {
        // Handle other types of errors, if necessary
        return rejectWithValue("An unknown error occurred");
      }
  }
})

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState,
  reducers: {
    testchatBot: (state, action) => {
      console.log("chatbot reducre called");
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(handleChatBot.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(handleChatBot.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(handleChatBot.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "An error occurred. Please try again.";
      })
      .addCase(getChatHistory.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getChatHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getChatHistory.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "An error occurred. Please try again.";
      })
      .addCase(sendChatBotFormData.pending, (state) => {
        state.chatHistoryLoader = true
      })
      .addCase(sendChatBotFormData.fulfilled, (state) => {
        state.chatHistoryLoader = false
      })
      .addCase(sendChatBotFormData.rejected, (state, action) => {
        state.chatHistoryLoader = false
        state.error = action.error as string
      })

      .addCase(getUserByIp.pending, (state) => {
        state.chatHistoryLoader = true
      })
      .addCase(getUserByIp.fulfilled, (state) => {
        state.chatHistoryLoader = false
      })
      .addCase(getUserByIp.rejected, (state, action) => {
        state.chatHistoryLoader = false
        state.error = action.error as string
      })
  },
});

export const { testchatBot } = chatbotSlice.actions;
export default chatbotSlice.reducer;
